import fitzpatrick from './fitzpatrick';
import glogau from './glogau';
import acneGrade from './acne_grade';
import acneScars from './acne_scars';
import cellulite from './cellulite';
import stretchMarks from './stretch_marks';
import bodyShape from './body_shape';
import fatDistribution from './fat_distribution';
import bodyImage from './body_image';
import bristol from './bristol';
import urineColor from './urine_color';
import rosacea from './rosacea';
import baumann from './baumann';
import diastasisRecti from './diastasis_recti';
import faceShape from './face_shape';
import eyebrowShape from './eyebrow_shape';
import nailShape from './nail_shape';
import hairType from './hair_type';
import norwoodHamilton from './norwood_hamilton';
import ludwig from './ludwig';
import savin from './savin';
import alopeciaAreata from './alopecia_areata';
import alopeciaEtiology from './alopecia_etiology';
import hairDysplasia from './hair_dysplasia';
import periorbitalHyperpigmentation from './periorbital_hyperpigmentation';
import melasmaLocation from './melasma_location';
import somatotype from './somatotype';

/**
 * Catálogo das escalas clínicas. Cada escala é um módulo de atendimento
 * próprio (a chave da escala é a chave do módulo) e mora num arquivo só,
 * nesta pasta. Tudo o mais (card, prévia, aba Saúde, relatório) sai daqui.
 *
 * Escala nova: ver docs/features/scale-modules/README.md.
 */
export const SCALES = Object.freeze([
  fitzpatrick,
  glogau,
  acneGrade,
  acneScars,
  cellulite,
  stretchMarks,
  bodyShape,
  fatDistribution,
  bodyImage,
  bristol,
  urineColor,
  rosacea,
  baumann,
  diastasisRecti,
  faceShape,
  eyebrowShape,
  nailShape,
  hairType,
  norwoodHamilton,
  ludwig,
  savin,
  alopeciaAreata,
  alopeciaEtiology,
  hairDysplasia,
  periorbitalHyperpigmentation,
  melasmaLocation,
  somatotype,
]);

export function getScale(key) {
  return SCALES.find((scale) => scale.key === key) || null;
}

export function isScaleKey(key) {
  return getScale(key) !== null;
}
